module.exports = __webpack_public_path__ + "static/media/12 Personal My Room 001_720.7d3125fa.jpeg";